import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastSettingsFn = /* @__PURE__ */ createRecipe('toast-settings', {}, [])

const toastSettingsVariantMap = {
  "status": [
    "success",
    "error",
    "warning",
    "neutral"
  ]
}

const toastSettingsVariantKeys = Object.keys(toastSettingsVariantMap)

export const toastSettings = /* @__PURE__ */ Object.assign(memo(toastSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastSettings',
  __getCompoundVariantCss__: toastSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastSettingsVariantKeys,
  variantMap: toastSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastSettingsVariantKeys)
  },
  getVariantProps: toastSettingsFn.getVariantProps,
})